<!--
 * @Author: your name
 * @Date: 2022-03-30 17:40:42
 * @LastEditTime: 2022-06-01 14:53:17
 * @LastEditors: Jokersora 674077946@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \mingyao\src\views\Home.vue
-->
<template>
  <div class="home">
    <!-- <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <div class="images" @mouseenter="me" @mouseleave="ml">
      <div
        class="images-show"
        v-for="(v, i) in imageClasses"
        :key="v"
        :class="v"
        :style="calcStyle(i)"
      >
        {{ v }}
      </div>
      <template v-if="show">
        <div class="preview" @click="changeIndex(-1)">◀</div>
        <div class="next" @click="changeIndex(1)">▶</div>
      </template>
    </div>
    <div class="wrap">
      <div class="intr">
        <div class="tit">公司简介 Company Profile</div>
        <div class="line"></div>
        <div class="intr-simple">专业深耕洁净无尘室行业</div>
        <div class="intr-text">
          江苏明耀工程技术有限公司建于二零零七年七月初，一家股份制性质的安装工程的有限责任公司，具有建筑机电安装工程专业承包贰级、消防设施工程专业承包贰级资质、建筑装饰装修工程专业承包贰级资质、电子与智能化工程专业承包贰级资质、特种工程专业承包（结构补强）资质、消防检测维保专项资质。
        </div>
        <div
          class="find-more"
          @click="
            () => {
              $router.push({ path: '/about' });
            }
          "
        >
          查看更多→
        </div>
      </div>
      <div class="intr">
        <div class="tit">服务项目 Company Services</div>
        <div class="line"></div>
        <div class="intr-simple">主营业务范围</div>
        <div class="intr-images">
          <div
            v-for="i in 6"
            class="img-services"
            :key="'p' + i"
            :style="{
              backgroundImage:
                'url(' + require('../assets/images/' + 'c' + i + '.jpg') + ')',
            }"
          >
            <div class="img-services-txt">
              <label>{{ texts[i - 1].item }}</label><br />
              <label class="img-services-txtzz">{{ texts[i - 1].name }}</label>
            </div>
          </div>
        </div>
        <div
          class="find-more"
          @click="
            () => {
              $router.push({ path: '/service' });
            }
          "
        >
          查看更多→
        </div>
      </div>
      <div class="intr">
        <div class="tit">公司业绩 Company Achievements</div>
        <div class="line"></div>
        <div class="intr-simple">近几年代表业绩</div>
        <div class="intr-images">
          <img
            v-for="i in 4"
            :key="'p' + i"
            :src="require('../assets/images/' + 'a' + i + '.jpg')"
          />
        </div>
        <div
          class="find-more"
          @click="
            () => {
              $router.push({ path: '/case' });
            }
          "
        >
          查看更多→
        </div>
      </div>
      <div class="intr zz">
        <div class="tit">公司资质 Company qualifications</div>
        <div class="line"></div>
        <div class="intr-simple">资信等级AAA级</div>
        <div class="intr-images">
          <img
            v-for="i in 2"
            :key="'q' + i"
            :src="require('../assets/images/' + 'q' + i + '.jpg')"
          />
        </div>
        <!-- <div class="intr-text">
          此外公司还拥有二级建造师9人，经专业培训持有特种操作证的员工15人。
        </div> -->
        <div
          class="find-more"
          @click="
            () => {
              $router.push({ path: '/power' });
            }
          "
        >
          查看更多→
        </div>
      </div>
      <Root />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Root from "@/components/Root.vue";
import myanimate from "@/utils/animate";
export default {
  name: "Home",
  components: {
    Root,
  },
  data: () => {
    return {
      imageClasses: ["a", "b", "c", "d","e","f","g"],
      bodyWidth: document.body.offsetWidth,
      index: 0,
      show: false,
      texts: [
        { item: "建筑机电安装工程", name: "建筑机电安装工程专业承包贰级" },
        { item: "消防施工", name: "消防设施工程专业承包贰级资质" },
        { item: "洁净无尘系统净化工程", name: "专业从事洁净净化工程服务" },
        { item: "装饰装修工程", name: "建筑装饰装修工程专业承包贰级资质" },
        { item: "建筑智能化工程", name: "电子与智能化工程专业承包贰级资质" },
        { item: "特种设备工程", name: "专业安装特种设备" },
      ],
    };
  },
  computed: {
    calcStyle() {
      return (i) => {
        return {
          "transform-origin": "50% 50% -" + this.bodyWidth / 2*Math.tan(64.2855/180*Math.PI) + "px",
          transform: "rotateY(" + ((i + this.index) * 360/7 + "deg") + ")",
        };
      };
    },
  },
  mounted() {
    this.autoChange();
  },
  methods: {
    changeIndex(t) {
      let _this = this;
      myanimate(
        this.index,
        this.index + t,
        300,
        null,
        (v) => {
          _this.index = v;
        },
        (v) => {
          _this.index = v;
        }
      );
    },
    autoChange() {
      let _this = this;
      this.interval = setInterval(() => {
        _this.changeIndex(-1);
      }, 5000);
    },
    me() {
      this.show = true;
      clearInterval(this.interval);
    },
    ml() {
      this.show = false;
      this.autoChange();
    },
  },
};
</script>
<style lang="less" scoped>
.images {
  height: 55%;
  width: 100%;
  border: 1px solid;
  position: absolute;
  perspective: 3000px;
  .images-show {
    width: 100%;
    height: 100%;
    position: absolute;
    backface-visibility: hidden;
  }
}
.preview,
.next {
  position: absolute;
  font-size: 2rem;
  text-align: center;
  width: 3rem;
  height: 10rem;
  line-height: 10rem;
  color: gray;
  top: calc(50% - 5rem);
  background-color: rgba(222, 222, 222, 0.4);
  opacity: 0.9;
  cursor: pointer;
}
.preview:hover,
.next:hover {
  opacity: 1;
  cursor: pointer;
}
.preview {
  left: 10rem;
}
.next {
  right:10rem;
}
.a {
  background-image: url(../assets/images/a.jpg);
}
.b {
  background-image: url(../assets/images/b.jpg);
}
.c {
  background-image: url(../assets/images/c.jpg);
}
.d {
  background-image: url(../assets/images/d.jpg);
}
.e {
  background-image: url(../assets/images/e.jpg);
}
.f {
  background-image: url(../assets/images/f.jpg);
}
.g {
  background-image: url(../assets/images/g.jpg);
}
.wrap {
  position: absolute;
  top: 55%;
  width: 100%;
}
.intr {
  margin-top: 2rem;
  padding:0 10% 0 10%;
  .tit {
    font-size: 1.6rem;
    text-align: center;
    padding: 1rem;
  }
  .line {
    width: 16rem;
    margin-left: calc(50% - 8rem);
    border-bottom: 2px solid rgb(102, 153, 204);
  }
  .intr-text {
    padding: 1rem 25% 1rem 25%;
    font-size: 0.9rem;
    line-height: 2rem;
  }
  .find-more {
    width: 16rem;
    height: 3rem;
    line-height: 3rem;
    margin-left: calc(50% - 8rem);
    font-size: 1.2rem;
    color: white;
    background-color: rgb(33, 150, 243);
    cursor: pointer;
    border-radius: 0.1rem;
  }
  .find-more:hover {
    background-color: rgb(68, 157, 68);
    cursor: pointer;
  }
  .intr-simple {
    color: rgb(150, 150, 150);
    font-size: 0.8rem;
    text-align: center;
    margin-top: 1rem;
  }
  .intr-images {
    padding: 0rem 3rem 0rem 3rem;
    img {
      width: calc(50% - 1rem);
      margin: 0.5rem;
    }
  }
}
.img-services {
  width: calc(33.33% - 1rem) !important;
  height: 20rem;
  display: inline-block;
  margin: 0.5rem;
  .img-services-txt {
    padding:8rem 5rem 0rem 5rem;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    font-size: 1.6rem;
    line-height: 2rem;
    color: white;
  }
  .img-services-txtzz {
    font-size: 1rem;
  }
}
.intr.zz{
  padding:0 20%;
}
</style>
